/**
 * Enum that defines event status options.
 */
export enum EventStatus {
  Tentative = 1,
  Confirmed = 3
}
